import {createTheme} from "@mui/material";

export const theme = createTheme({
    palette: {
        primary: { main: '#578AD6' },
        secondary: { main: '#FF7F2D' }
    },
});
